import { render, staticRenderFns } from "./Chromosomes.vue?vue&type=template&id=2e8173b8"
import script from "./Chromosomes.vue?vue&type=script&lang=js"
export * from "./Chromosomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports